import { byPrefixAndName } from "@awesome.me/kit-de80aecb6a/icons"
import { css } from "@emotion/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import { Card } from "react-bootstrap"

const componentStyles = css`
    width: 25rem;

    .card-header {
        color: #002345;
        font-weight: bold;
        border-bottom: none;
        background-color: #fff;
    }

    .custom-card {
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        transition: transform 0.2s ease-in-out;
        margin-bottom: 20px;
    }

    .custom-card:hover {
        transform: scale(1.02);
    }

    .custom-text {
        font-size: 1rem;
        line-height: 1.6;
        margin-bottom: 0.4rem;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .icon-text {
        display: flex;
        align-items: center;
    }

    .icon-text .fa-icon {
        margin-right: 5px;
    }

    .email,
    .phone {
        cursor: pointer;
    }

    .email:hover,
    .phone:hover {
        color: #0056b3;
    }
`

const HelpCenterCard = () => {
    return (
        <div
            css={componentStyles}
            className="text-center">
            <Card className="w-100 custom-card">
                <Card.Header className="text-center card-header">Help Center</Card.Header>
                <Card.Body className="custom-card-body">
                    <div className="custom-text">
                        <h6>General Help:</h6>
                        <div className="icon-text">
                            <FontAwesomeIcon
                                icon={byPrefixAndName.fal["user"]}
                                className="fa-icon"
                            />
                            Bjorn Gundersen
                        </div>
                        <div className="icon-text">
                            <FontAwesomeIcon
                                icon={byPrefixAndName.fal["phone"]}
                                className="fa-icon"
                            />
                            <a
                                href="tel:4844250302"
                                className="phone">
                                484-425-0302
                            </a>
                        </div>
                        <div className="icon-text">
                            <FontAwesomeIcon
                                icon={byPrefixAndName.fal["envelope"]}
                                className="fa-icon"
                            />
                            <a
                                href="mailto:bgundersen@gaig.com"
                                className="email">
                                bgundersen@gaig.com
                            </a>
                        </div>
                    </div>
                    <div className="custom-text">
                        <h6>Claims Help:</h6>
                        <div className="icon-text">
                            <FontAwesomeIcon
                                icon={byPrefixAndName.fal["envelope"]}
                                className="fa-icon"
                            />
                            <a
                                href="mailto:EnvDiv-Claims@GAIG.com"
                                className="email">
                                EnvDiv-Claims@GAIG.com
                            </a>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    )
}

export default HelpCenterCard
